import request from '@/utils/request'
import environment from '@/utils/environment'

export function userLogin(params) {
  localStorage.setItem('token', 'token')
  return request({
    url: 'admin/login',
    method: 'post',
    params
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'post'
  })
}
export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function getcaptcha() {
  // // var api =`${process.env.VUE_APP_BASE_URL}/service-admin/captcha/index`
  // console.log(process.env.VUE_APP_BASE_URL)
  // var api = environment.verification()
  // console.log(api)
  // return `?t=${time}`
  // return request({
  //   url: 'captcha/index',
  //   method: 'get'
  // })
}
